import { useQuery } from '@tanstack/react-query'
import { isDemoSession } from '@/auth/oidc'
import { keys } from '@/api/hooks/shared/keys'
import {
  demoSearchHierarchyPage,
  hierarchySearchLive,
  searchHierarchyAggregate,
} from '@/api/map/hierarchySearch'

/** Lab Aggregate Hierarchy Search results (`Member/searchHierarchyAggregate`). */
export function useSearchHierarchyPage(
  filter: string[],
  opts: { page?: number; enabled?: boolean } = {},
) {
  const page = opts.page ?? 1
  const enabled = (opts.enabled ?? true) && filter.length > 0

  return useQuery({
    queryKey: keys.searchHierarchyPage({ filter, page }),
    enabled,
    queryFn: async () => {
      if (!hierarchySearchLive() || isDemoSession()) {
        return demoSearchHierarchyPage(filter)
      }
      return searchHierarchyAggregate({ filter, page, accessLevel: 'Aggregate' })
    },
  })
}
